/** Match agent skill ``SKILL.md`` paths under ``/skills/``. */
const SKILL_MD_PATH = /^\/skills\/([a-z0-9-]+)\/SKILL\.md$/

/** Friendly activity copy for skill playbook loads (not the raw skill id). */
const SKILL_ACTIVITY_COPY: Record<string, {pending: string; done: string; failed: string}> = {
  'image-embedding-s3': {
    pending: 'Loading images…',
    done: 'Showing images',
    failed: 'Could not load images',
  },
  'bio-exec': {
    pending: 'Loading analysis tools…',
    done: 'Loaded analysis tools',
    failed: 'Could not load analysis tools',
  },
  'omicsbox-feature-howto': {
    pending: 'Looking up OmicsBox help…',
    done: 'Looked up OmicsBox help',
    failed: 'Could not load OmicsBox help',
  },
  'internet-search-protocol': {
    pending: 'Preparing web search…',
    done: 'Prepared web search',
    failed: 'Could not prepare web search',
  },
  'cwl-workflow-execution': {
    pending: 'Preparing workflow run…',
    done: 'Prepared workflow run',
    failed: 'Could not prepare workflow run',
  },
  'bioinformatics-recipes': {
    pending: 'Loading analysis recipes…',
    done: 'Loaded analysis recipes',
    failed: 'Could not load analysis recipes',
  },
}

export function skillNameFromReadFilePath(path: string): string | null {
  const p = path.trim()
  const m = SKILL_MD_PATH.exec(p)
  return m ? m[1] : null
}

export function skillNameFromReadFileArgs(args: Record<string, unknown>): string | null {
  for (const key of ['file_path', 'path', 'target_file', 'filepath']) {
    const v = args[key]
    if (typeof v === 'string' && v.trim()) {
      const name = skillNameFromReadFilePath(v)
      if (name) return name
    }
  }
  return null
}

function formatSkillDisplayLabel(skillName: string): string {
  const key = skillName.trim()
  if (!key) return 'skill'
  return key.replace(/-/g, ' ')
}

/** One-line chat history label for a skill load (no extra "(loading…)" suffix). */
export function formatSkillActivityLabel(
  skillName: string,
  opts: {pending?: boolean; failed?: boolean} = {},
): string {
  const key = skillName.trim() || 'skill'
  const copy = SKILL_ACTIVITY_COPY[key]
  if (copy) {
    if (opts.failed) return copy.failed
    if (opts.pending) return copy.pending
    return copy.done
  }
  const readable = formatSkillDisplayLabel(key)
  if (opts.failed) return `Could not load ${readable}`
  if (opts.pending) return `Loading ${readable}…`
  return `Used skill ${readable}`
}
